import { Check, Sparkles, Trash2 } from "lucide-react";
import { AuthImage } from "@/components/AuthImage";
import { catColor, catOf } from "./usePhotoCategories";

function Badge({ photo, categories }) {
  if (photo.ai_status === "pending") {
    return <span className="rounded-full px-2 py-0.5 text-[10px] font-semibold text-white bg-black/60 flex items-center gap-1 animate-pulse" data-testid="photo-sorting-badge"><Sparkles className="w-3 h-3" />Sorting…</span>;
  }
  const cat = catOf(photo, categories);
  return (
    <span className="rounded-full px-2 py-0.5 text-[10px] font-semibold text-white flex items-center gap-1" style={{ backgroundColor: catColor(cat, categories) }} data-testid="photo-category-badge">
      {photo.category_source === "ai" && cat !== "Unsorted" && <Sparkles className="w-3 h-3" aria-label="Sorted by AI" />}{cat}
    </span>
  );
}

export function PhotoTile({ photo, categories, selecting, selected, canDelete, onOpen, onToggle, onDelete }) {
  return (
    <div className={`group relative aspect-square overflow-hidden rounded-lg bg-zinc-100 dark:bg-zinc-900 ring-offset-2 ring-offset-background transition-shadow duration-200 ${selected ? "ring-2 ring-[#FF5F15]" : ""}`} data-testid={`job-photo-${photo.id}`}>
      <button type="button" onClick={selecting ? onToggle : onOpen} className={`block w-full h-full ${selecting ? "cursor-pointer" : "cursor-zoom-in"}`}
        data-testid={`job-photo-expand-${photo.id}`} aria-label={selecting ? "Select photo" : "Open photo"} aria-pressed={selecting ? selected : undefined}>
        <AuthImage path={photo.storage_path} width={320} alt={photo.caption || "Site photo"}
          className={`w-full h-full transition-transform duration-500 ease-out ${selected ? "scale-[0.94]" : "group-hover:scale-[1.04]"}`} />
      </button>
      <span className="pointer-events-none absolute top-2 left-2"><Badge photo={photo} categories={categories} /></span>
      <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent px-2.5 pb-2 pt-8 text-white">
        {photo.caption && <p className="text-xs font-medium leading-snug line-clamp-2">{photo.caption}</p>}
        <p className="text-[10px] text-white/75 truncate">{photo.uploaded_by_name} · {photo.taken_at}</p>
      </div>
      {selecting ? (
        <button type="button" onClick={onToggle} aria-label="Toggle selection" data-testid={`job-photo-select-${photo.id}`}
          className={`absolute top-2 right-2 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${selected ? "bg-[#FF5F15] border-[#FF5F15]" : "bg-black/30 border-white"}`}>
          {selected && <Check className="w-3.5 h-3.5 text-white" />}
        </button>
      ) : canDelete && (
        <button type="button" onClick={onDelete} aria-label="Delete photo" data-testid={`job-photo-delete-${photo.id}`}
          className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/50 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 focus:opacity-100 [@media(hover:none)]:opacity-100 hover:bg-red-600 transition-[opacity,background-color]">
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}
